<ng-container *ngIf="lastDownloadTimeAgo; else noDownloadLastTime">
  <span class="download-status download-last-24hours">
    {{'downloaded'|translate}} {{lastDownloadTimeAgo}}
  </span>
</ng-container>

<ng-template #noDownloadLastTime>
  <span
    [ngClass]="{
      'error': (
        _data.Status === TACHO_FILE_STATUS.WaitingForIgnition ||
        _data.Status === TACHO_FILE_STATUS.DriverCardNotFound ||
        _data.Status === TACHO_FILE_STATUS.FleetCardBusy ||
        _data.Status === TACHO_FILE_STATUS.TachoCommunicationErrorX ||
        _data.Status === TACHO_FILE_STATUS.TachoCommunicationErrorN4 ||
        _data.Status === TACHO_FILE_STATUS.TachoCommunicationErrorN5 ||
        _data.Status === TACHO_FILE_STATUS.AuthorizationException ||
        _data.Status === TACHO_FILE_STATUS.DownloadException ||
        _data.Status === TACHO_FILE_STATUS.DownloadError ||
        _data.Status === TACHO_FILE_STATUS.FleetCardCommunicationError ||
        _data.Status === TACHO_FILE_STATUS.FleetCardAuthenticationFail
      ),
      'in-progress-status': _data.Status === TACHO_FILE_STATUS.DownloadInProgress
    }"
    class="download-status"
  >
    <div class="loader"></div>

    {{ _data.Status === TACHO_FILE_STATUS.Unknown && !_data.NextPlannedLoadDate ? ('filesStatus.noScheduledDownload' | translate ): '' }}
    {{ (_data.Status === TACHO_FILE_STATUS.Unknown && _data.NextPlannedLoadDate || _data.Status === TACHO_FILE_STATUS.Waiting) ? (_data.NextPlannedLoadDate | scheduleDate) : '' }}
    {{ _data.Status === TACHO_FILE_STATUS.AuthorizationInProgress ? ('filesStatus.connectingToVehicle'|translate) : '' }}
    {{ _data.Status === TACHO_FILE_STATUS.DownloadInProgress ? (('filesStatus.downloadingData' | translate) + '(' + (_data.FilesStatus.PercentageDownloaded) + '%)') : '' }}
    {{ _data.Status === TACHO_FILE_STATUS.VehicleOffline ? ('filesStatus.vehicleOffline'|translate) : '' }}
    {{ _data.Status === TACHO_FILE_STATUS.WaitingForIgnition ? ('filesStatus.waitingForIgnition'|translate) : '' }}
    {{ _data.Status === TACHO_FILE_STATUS.DriverCardNotFound ? ('filesStatus.driverCardNotFound'|translate) : '' }}
    {{ _data.Status === TACHO_FILE_STATUS.FleetCardBusy ? ('filesStatus.tachographBusy'|translate) : '' }}
    {{ _data.Status === TACHO_FILE_STATUS.TachoCommunicationErrorX ? ('filesStatus.connectionError'|translate) : '' }}
    {{ _data.Status === TACHO_FILE_STATUS.TachoCommunicationErrorN4 ? ('filesStatus.connectionError'|translate) : '' }}
    {{ _data.Status === TACHO_FILE_STATUS.TachoCommunicationErrorN5 ? ('filesStatus.configurationError'|translate) : '' }}
    {{ _data.Status === TACHO_FILE_STATUS.AuthorizationException ? ('filesStatus.internalError'|translate) : '' }}
    {{ _data.Status === TACHO_FILE_STATUS.DownloadException ? ('filesStatus.internalError'|translate) : '' }}
    {{ _data.Status === TACHO_FILE_STATUS.DownloadError ? ('filesStatus.internalError'|translate) : '' }}
    {{ _data.Status === TACHO_FILE_STATUS.FleetCardCommunicationError ? ('filesStatus.systemCardAccessError'|translate) : '' }}
    {{ _data.Status === TACHO_FILE_STATUS.FleetCardAuthenticationFail ? ('filesStatus.systemCardAccessError'|translate) : '' }}
  </span>
</ng-template>
